import React, {useRef, useState, useEffect} from 'react';
import store from 'web/redux/store';
/**
 * @hooks usePrint
 * @description 提供列印 PDF 文件的功能，包含一個隱藏的 iframe 用於載入和列印文件。
 * @returns {print: (function(*=): Promise<void>), PrintFrame: (function(): JSX.Element)}
 */
export const usePrint = () => {
  const iframeRef = useRef(null);
  const [printBlobUrl, setPrintBlobUrl] = useState(null);

  useEffect(() => {
    return () => {
      if (printBlobUrl) {
        URL.revokeObjectURL(printBlobUrl);
      }
    };
  }, [printBlobUrl]);

  const iframeLoaded = () => {
    try {
      if (iframeRef.current && printBlobUrl) {
        const iframeWindow = iframeRef.current.contentWindow;
        iframeWindow.focus();
        iframeWindow.print();
        setTimeout(() => {
          setPrintBlobUrl(null);
        }, 1000);
      }
    } catch (error) {
      console.error('Print error:', error);
    }
  };

  const getReportBlob = async (url) => {
    try {
      const token = store.getState().auth.token;
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.ok) return response.blob();
    } catch (error) {
      console.error('Fetch print document error:', error);
    }
  };

  const print = async (url) => {
    const blob = await getReportBlob(url);
    const blobUrl = URL.createObjectURL(blob);
    setPrintBlobUrl(blobUrl);
  };

  const download = async (url) => {
    const blob = await getReportBlob(url);
    const a = document.createElement('a');
    const name = url.split('/').pop();
    console.log('dowload report:', name);
    a.href = URL.createObjectURL(blob);
    a.download = name;
    a.click();
    URL.revokeObjectURL(a.href);
  };

  const PrintFrame = () => {
    return (
      printBlobUrl && (
        <iframe
          ref={iframeRef}
          hidden
          src={printBlobUrl}
          onLoad={iframeLoaded}
        ></iframe>
      )
    );
  };
  return {
    download,
    print,
    PrintFrame,
    clearPrintBlobUrl: () => setPrintBlobUrl(null),
  };
};
